import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQ } from "../../data/content";
import { Reveal, SectionHeading } from "../shared/Primitives";

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-16 sm:py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-6 sm:px-12">
        <div className="text-center flex flex-col items-center">
          <SectionHeading
            overline="Resolvemos tus dudas"
            title="Preguntas frecuentes"
          />
        </div>

        <Reveal className="mt-14">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#B2967D]/30"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left text-base sm:text-lg font-bold text-black hover:no-underline hover:text-[#7D5A44]"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-lg font-light text-black/60 leading-relaxed">
                  <p>{item.a}</p>
                  {item.bullets && (
                    <ul className="mt-4 space-y-2">
                      {item.bullets.map((b) => (
                        <li key={b} className="flex items-center gap-3">
                          <span className="w-1.5 h-1.5 bg-[#7D5A44] shrink-0" />
                          {b}
                        </li>
                      ))}
                    </ul>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
